import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@service/auth.service';

export interface ElectronLoginCredentials {
    name: string;
    email: string;
}

@Component({
    selector: 'app-electron-login',
    templateUrl: './electron-login.component.html',
    styleUrls: ['./electron-login.component.css'],
    standalone: false,
})
export class ElectronLoginComponent {
    name = '';
    email = '';

    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    @Output() login = new EventEmitter<ElectronLoginCredentials>();

    onSubmit(): void {
        if (!this.email || !this.name) return;
        this.authService.setCurrentUser(this.name, '123', this.email);
        this.router.navigateByUrl('/home');
    }

    onReset(): void {
        this.name = '';
        this.email = '';
    }
}
